module.exports = "/assets/60b3e9e16eac41ce95b70ff67125ceb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LX.png
// module id = 1595
// module chunks = 0